import { render, staticRenderFns } from "./FilterFieldDropdown.vue?vue&type=template&id=16987d5a&lang=pug"
import script from "./FilterFieldDropdown.vue?vue&type=script&lang=js"
export * from "./FilterFieldDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports